export default [
    { "nome": "Álcool (Etanol)", "sigla": "ALC" },
    { "nome": "Álcool/Gasolina (Flex)", "sigla": "FLEX" },
    { "nome": "Gasolina", "sigla": "GAS" },
    { "nome": "Gás Natural (GNV)", "sigla": "GNV" },
    { "nome": "Diesel", "sigla": "DSL" },
    { "nome": "Hidrogênio", "sigla": "H2" },
    { "nome": "Elétrico", "sigla": "ELET" }
];